import PropTypes from 'prop-types'
import { useState, useEffect, useCallback } from 'react'
import * as publicacionService from '../servicios/publicacionesService'
import Borde from './administrar/borde/Borde'

const Metadatos = ({ idPublicacion, editable = false }) => {
  const [metadatos, setMetaDatos] = useState([])
  const [unidades, setUnidades] = useState({})

  const metadato = { idPublicacion: idPublicacion, idMetadato: '', valor: '' }

  const obtenerMetaDatos = useCallback(async () => {
    if (idPublicacion > 0) {
      const { data } = await publicacionService.buscarMetadato(idPublicacion)
      setMetaDatos(data)

      const unidadesExistentes = {}
      data.forEach((metadato) => {
        if (
          (metadato.idMetadatoTipo === 'number' ||
            metadato.idMetadatoTipo === 'number_unit') &&
          metadato.valor
        ) {
          const partes = metadato.valor.split(' ')
          if (partes.length > 1) {
            unidadesExistentes[metadato.idMetaDato] = partes.slice(1).join(' ')
          }
        }
      })
      setUnidades(unidadesExistentes)
    }
  }, [idPublicacion])

  useEffect(() => {
    obtenerMetaDatos()
  }, [obtenerMetaDatos])

  const onHandleBlur = (e, idMetaDato, esUnidad = false) => {
    let valorFinal = e.target.value

    if (esUnidad) {
      const metadatoActual = metadatos.find((m) => m.idMetaDato === idMetaDato)
      const valorBase = metadatoActual?.valor?.split(' ')[0] || ''
      valorFinal = `${valorBase} ${e.target.value}`.trim()
    } else {
      const unidad = unidades[idMetaDato]
      if (unidad) {
        valorFinal = `${e.target.value} ${unidad}`.trim()
      }
    }

    metadato.idMetadato = idMetaDato
    metadato.valor = valorFinal
    publicacionService.InsertarMetadato(metadato)
  }

  const handleUnidadChange = (e, idMetaDato) => {
    setUnidades((prev) => ({
      ...prev,
      [idMetaDato]: e.target.value
    }))
    if (e.target.value) {
      onHandleBlur(e, idMetaDato, true)
    }
  }

  const updateEstado = (e, index, idMetaDato) => {
    const nuevoValor = e.target.value
    const unidad = unidades[idMetaDato]
    const valorFinal = unidad ? `${nuevoValor} ${unidad}`.trim() : nuevoValor

    setMetaDatos((prev) =>
      prev.map((item, i) => (i === index ? { ...item, valor: valorFinal } : item))
    )
  }
  return (
    <>
      {metadatos.filter((m) => m.valor !== '').length > 0 && (
        <Borde titulo="Caracterí­sticas del Producto">
          {metadatos.map(
            (metadato, index) =>
              metadato.valor && (
                <div key={metadato.idMetaDato} className="row">
                  <div className="d-none d-md-block col-md-3 text-right">
                    {metadato.etiqueta}:
                  </div>
                  <div className="d-block d-md-none col-12">{metadato.etiqueta}: </div>
                  <div className="col-12 col-md-9">
                    {editable ? (
                      metadato.idMetadatoTipo === 'boolean' ? (
                        <select
                          className="input-text-bordered w-25"
                          name={'metadatos'}
                          value={metadato.valor || ''}
                          onChange={(e) => {
                            updateEstado(e, index, metadato.idMetaDato)
                            onHandleBlur(e, metadato.idMetaDato)
                          }}
                        >
                          <option value={''}>Seleccione</option>
                          <option value={'Si'}>Si</option>
                          <option value={'No'}>No</option>
                        </select>
                      ) : metadato.idMetadatoTipo === 'number' ||
                        metadato.idMetadatoTipo === 'number_unit' ? (
                        <>
                          <input
                            type="number"
                            name={'metadatos'}
                            className="input-text-bordered w-25"
                            value={metadato.valor?.split(' ')[0] || ''}
                            onChange={(e) => updateEstado(e, index, metadato.idMetaDato)}
                            onBlur={(e) =>
                              e.target.value && onHandleBlur(e, metadato.idMetaDato)
                            }
                          />
                          <input
                            type="text"
                            placeholder="Unidad"
                            name={`unidad_${metadato.idMetaDato}`}
                            className="input-text-bordered w-25"
                            value={unidades[metadato.idMetaDato] || ''}
                            onChange={(e) => {
                              setUnidades((prev) => ({
                                ...prev,
                                [metadato.idMetaDato]: e.target.value
                              }))
                              updateEstado(
                                {
                                  target: {
                                    value: metadato.valor?.split(' ')[0] || ''
                                  }
                                },
                                index,
                                metadato.idMetaDato
                              )
                            }}
                            onBlur={(e) =>
                              e.target.value && handleUnidadChange(e, metadato.idMetaDato)
                            }
                          />
                        </>
                      ) : (
                        <input
                          type="text"
                          className="input-text-bordered w-25"
                          name={metadato.idMetaDato}
                          value={metadatos[index].valor}
                          onChange={(e) => updateEstado(e, index, metadato.idMetaDato)}
                          onBlur={(e) => onHandleBlur(e, metadato.idMetaDato)}
                        ></input>
                      )
                    ) : (
                      <div>{metadato.valor}</div>
                    )}
                  </div>
                </div>
              )
          )}
        </Borde>
      )}
    </>
  )
}

Metadatos.propTypes = {
  idPublicacion: PropTypes.number.isRequired,
  editable: PropTypes.bool
}

export default Metadatos
